import { useLocale, LanguagePicker } from "../context/LocaleContext";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { topNav } from "../mock";
import { Button } from "./ui/button";
import { Heart } from "lucide-react";

export default function TopBar() {
  const { t } = useLocale();
  const location = useLocation();
  return (
    <header
      className="sticky top-0 z-30 border-b backdrop-blur-xl"
      style={{ background: "rgba(8,20,17,0.78)", borderColor: "var(--sy-border)" }}
    >
      <div className="flex h-16 items-center justify-end gap-1 px-3 lg:px-8">
        <nav className="hidden md:flex items-center gap-1">
          {topNav.map((item) => {
            const Icon = item.icon;
            const active = location.pathname === item.to;
            return (
              <Link
                key={item.id}
                to={item.to}
                className="group relative flex items-center gap-2 rounded-lg px-2 py-2 text-sm font-medium transition-colors"
                style={{ color: active ? "var(--sy-gold-bright)" : "var(--sy-text-dim)" }}
              >
                <Icon size={16} style={{ color: active ? "var(--sy-gold)" : "currentColor" }} />
                <span className="group-hover:text-[color:var(--sy-gold-bright)] transition-colors">
                  {t(item.label)}
                </span>
                {active && (
                  <span
                    className="absolute -bottom-[1px] left-4 right-4 h-[2px] rounded-full"
                    style={{ background: "var(--sy-gold)" }}
                  />
                )}
              </Link>
            );
          })}
        </nav>

        <LanguagePicker />
        <Link to="/dua-bagisi" className="ml-2">
          <Button
            className="gap-2 font-semibold shadow-md hover:brightness-110 transition-all"
            style={{
              background: "linear-gradient(180deg,#e8d5a8 0%,#d6b876 55%,#b8954f 100%)",
              color: "#1a150b",
            }}
          >
            <Heart size={16} className="fill-current" />
            {t("Dua Bağışı")}
          </Button>
        </Link>
      </div>
    </header>
  );
}

